import { defaultOrderDisplay } from "../context/OrderContext";
import { Order } from "./order.interface";

export interface SearchType {
  id: string,
  userId: string,
  locationId: string,
  searchedAt: string,
  vin: string,
  year: number,
  make: string,
  model: string
  keyType: string,
  price: number,
  lotNumber?: string,
  sellerName?: string
}

export interface SearchContextType {
  searchList: SearchLine[],
  searchOrderMap: Map<string, Order>,
  displayOrder: Order,
  addToCartVin?: string,
  addToCartItem?: SearchType,
  addToCartDialogOpen: boolean,
  searchOptionalItemMap?: Map<string, OptionalItem>
}
 
export const defaultSearchContext: SearchContextType = {
  searchList: [],
  searchOrderMap: new Map<string, Order>(),
  displayOrder: defaultOrderDisplay,
  addToCartDialogOpen: false
};


export const defaultSearchResponse: SearchType = {
  id: '',
  userId: '',
  locationId: '',
  searchedAt: '',
  vin: '',
  year: 0,
  make: '',
  model: '',
  keyType: '',
  price: 0
};